module.exports = __webpack_public_path__ + "img/gong1.70a436f0.png";